import { FormErrors, JoinRequestFormData } from '../types';

export const validateForm = (data: JoinRequestFormData): FormErrors => {
  const errors: FormErrors = {};

  // Full name validation
  if (!data.fullName.trim()) {
    errors.fullName = 'الاسم الكامل مطلوب';
  } else if (data.fullName.trim().length < 2) {
    errors.fullName = 'الاسم الكامل يجب أن يكون على الأقل حرفين';
  } else if (data.fullName.trim().length > 100) {
    errors.fullName = 'الاسم الكامل يجب ألا يتجاوز 100 حرف';
  } else if (!/^[a-zA-Z\s\u0600-\u06FF]+$/.test(data.fullName.trim())) {
    errors.fullName = 'الاسم الكامل يجب أن يحتوي على أحرف ومسافات فقط';
  }

  // Birth date validation
  if (!data.birthDate) {
    errors.birthDate = 'تاريخ الميلاد مطلوب';
  } else {
    const birthDate = new Date(data.birthDate);
    const today = new Date();
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 1);

    if (isNaN(birthDate.getTime())) {
      errors.birthDate = 'يرجى إدخال تاريخ صحيح';
    } else if (birthDate > today) {
      errors.birthDate = 'تاريخ الميلاد لا يمكن أن يكون في المستقبل';
    } else if (birthDate > minDate) {
      errors.birthDate = 'يجب أن يكون عمرك سنة واحدة على الأقل للانضمام';
    }
  }

  // Phone number validation
  if (!data.phoneNumber.trim()) {
    errors.phoneNumber = 'رقم الهاتف مطلوب';
  } else if (!/^[0-9]+$/.test(data.phoneNumber.trim())) {
    errors.phoneNumber = 'رقم الهاتف يجب أن يكون أرقام فقط';
  }

  return errors;
};

export const hasErrors = (errors: FormErrors): boolean => {
  return Object.keys(errors).length > 0;
};

export const formatDate = (dateString: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}; 